import * as React from 'react';
export const shinhanSvg = React.forwardRef(function shinhanSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0046FF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16 4a12 12 0 1 0 0 24 12 12 0 0 0 0-24Zm.252 21.81c-1.436.198-3.773-.163-5.362-1.165a7.27 7.27 0 0 1-2.741-3.094c-.548-1.136-.806-2.514-.222-2.447.272.032.508.548 1.04 1.224.362.46.693.848.942.901.113.024.198-.027.284-.178.15-.286.35-.829.71-1.267.285-.33.646-.493.845.327.094.393.168.791.22 1.192.064.518.098.828.278.915.181.088.465-.023.938-.198.34-.127.774-.288 1.324-.445.509-.145.83-.07.505.717a7.079 7.079 0 0 1-.858 1.476.284.284 0 0 0 .042.397c.32.251.677.452 1.058.596.356.149.72.275 1.093.379.446.139.365.596-.096.67Zm6.157-2.583c-.445.727-1.39 1.512-2.518 2.036-.173.078-.356.052-.397-.087-.042-.14.057-.262.168-.397 1.48-1.919.382-3.679-2.008-5.045-1.763-1.01-2.885-1.589-4.188-2.356-3.816-2.246-4.552-4.202-4.701-5.362-.376-2.924 2.041-5.114 4.528-5.643.077-.016.276-.047.34.118.063.164-.084.286-.17.337-1.12.608-2.212 1.9-2.093 3.353.066.806.412 1.966 2.594 3.523 1.317.94 2.932 1.71 6.185 3.66 3.438 2.062 3.047 4.574 2.258 5.863h.002Zm.536-10.983c-.784.962-1.569.596-2.172-.748-.378-.845-.872-1.047-1.222-.827-.381.24-.23.82.199 1.486a1.02 1.02 0 0 1-.137 1.251 1.42 1.42 0 0 1-1.349.326c-.967-.215-1.918-1.51-1.223-4.34.28-1.14-.268-1.628-.616-2.067-.173-.22-.199-.354-.131-.441.067-.088.23-.103.514-.044.374.078.926.268 1.375.338.329.047.661.062.993.045a4.685 4.685 0 0 1 2.403.473c1.235.612 1.36 1.664.673 1.589a3.108 3.108 0 0 1-.794-.332c-.169-.081-.316-.109-.423-.03a.3.3 0 0 0-.072.378c.153.324.672.49 1.375.683 1.225.334 1.25 1.474.607 2.26Z',
      fill: '#fff',
    }),
  );
});
shinhanSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var shinhan = {
  category: 'brand',
  colorable: false,
  name: 'shinhan',
  svg: shinhanSvg,
};
